//
//
//
//
//
//
//
//
//
import Payment from './Payment.vue';
import Socials from './Socials.vue';
export default {
  name: 'PaymentSocials',
  components: {
    Payment: Payment,
    Socials: Socials
  },
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};